module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/323.7dde6e19.png";